import { render, staticRenderFns } from "./eVoucherCard.vue?vue&type=template&id=36b7aeeb&scoped=true&"
import script from "./eVoucherCard.vue?vue&type=script&lang=js&"
export * from "./eVoucherCard.vue?vue&type=script&lang=js&"
import style0 from "./eVoucherCard.vue?vue&type=style&index=0&id=36b7aeeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b7aeeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b7aeeb')) {
      api.createRecord('36b7aeeb', component.options)
    } else {
      api.reload('36b7aeeb', component.options)
    }
    module.hot.accept("./eVoucherCard.vue?vue&type=template&id=36b7aeeb&scoped=true&", function () {
      api.rerender('36b7aeeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/eVoucher/components/eVoucherCard.vue"
export default component.exports